import Vue from 'vue'
import Router from 'vue-router'

import Home from '@/components/Home'
import Controls from '@/components/Controls'
import Screenshots from '@/components/Screenshots'
import Download from '@/components/Download'
import Contact from '@/components/Contact'
import Artworks from '@/components/Artworks'
import Links from '@/components/Links'

//import Showcase from '@/components/Showcase'

Vue.use(Router);

Vue.mixin({
	mounted() {
        this.isMobile=this.touchCapabilities();
        this.goTo='';

        if(localStorage.colorTheme){
        	this.colorTheme=localStorage.colorTheme;
        	this.setTheme();
    	}else{
        	this.colorTheme="blue";
        	localStorage.colorTheme=this.colorTheme;
    	}
    },
    methods: {
      setTheme:function(){
        switch(this.colorTheme){
          	case "red": document.getElementById("colorTheme").setAttribute("href","/static/css/Terminal_Red.css");break;
          	case "green": document.getElementById("colorTheme").setAttribute("href","/static/css/Terminal_Green.css");break;
          	case "blue": document.getElementById("colorTheme").setAttribute("href","/static/css/Terminal_Blue.css");break;
        	}
    	},
        touchCapabilities: function () { return (('ontouchstart' in window) || (navigator.MaxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0));},
        stopPropagation: function(e){ if (!e) e = window.event; if (e.stopPropagation) {e.stopPropagation();}else{e.cancelBubble = true;}; },
        initGallery: function(){

        	this.gallery=document.getElementById("gallery");
			this.viewer = undefined;
			this.viewerImg = undefined;
			this.imgCounter=0;
			this.imgTitle = undefined;
			this.imgLabel = undefined;
			this.galleryLength = undefined;
			this.currentTarget=undefined;
			this.galleryElements=undefined;
			this.galleryIndex=0;
			this.prevBtn=undefined;
			this.nextBtn=undefined;
			this.closeBtn=undefined;
			this.setUpGallery();

        },
 		switchImg:function(e){
			
				if(e.target.style.animationName ==='fadeOutImg') {
					e.target.style.animationName = 'fadeInImg';
					e.target.src=this.currentTarget.src;
				}else if(e.target.style.animationName==='fadeInImg'){
					e.target.style.animationName = '';
				}
			
		},
   		galleryIndexHandler:function(){
			if(this.galleryIndex<0){this.galleryIndex=this.galleryLength-1;}
			else if(this.galleryIndex>=this.galleryLength){this.galleryIndex=0;}
			this.currentTarget=this.galleryElements[this.galleryIndex];
			this.updateInfos();
		},
		updateInfos:function (){
			var infos=this.currentTarget.nextElementSibling;
			this.imgTitle.textContent=infos.getAttribute("title");
			this.imgLabel.textContent=infos.getAttribute("label");
			this.imgCounter.textContent=(parseInt(this.currentTarget.getAttribute("index"))+1)+'/'+this.galleryLength;
		},
		closeViewer:function (){
			this.viewer.style.animationName ='fadeOut';
		},
		nextImg:function(e){
			this.galleryIndex+=1;
			this.galleryIndexHandler();
			this.updateInfos();
			if(this.nextBtn.style.animationName==="fadeBtn"){
				this.nextBtn.style.animation = "";
				this.nextBtn.offsetHeight;
			};
			this.viewerImg.style.animationName ='fadeOutImg';
			this.nextBtn.style.animationName ='fadeBtn';
		},
		prevImg:function (e){
			this.galleryIndex-=1;
			this.galleryIndexHandler();
			this.updateInfos();
			if(this.prevBtn.style.animationName==="fadeBtn"){
				this.prevBtn.style.animation ="";
				this.prevBtn.offsetHeight;
			};
			this.viewerImg.style.animationName ='fadeOutImg';
			this.prevBtn.style.animationName ='fadeBtn';	
		},
		openViewer:function(e){

			this.currentTarget=e.target;
			this.viewerImg.src=e.target.src;
			this.galleryIndex=parseInt(e.target.getAttribute("index"));
			this.updateInfos();
			this.viewer.style.visibility="visible";
			this.viewer.style.animationName = 'fadeIn';
		},
		endAnim:function(e){

				e.target.style.animationName = '';

		},
		viewerAnimEnd:function(e){
			
					if(e.target.style.animationName==="fadeIn"){
					e.target.style.visibility="visible";
					e.target.style.animationName = '';
					}else if(e.target.style.animationName==="fadeOut"){
					e.target.style.visibility="hidden";
					e.target.style.animationName = '';
					}
			
		},
        setUpGallery:function(){

			var parent=document.body;

			var mc=document.getElementById("mainContainer");
			
			this.viewer = document.createElement("div");
			this.viewer.id = "viewer";
			
			this.viewerImg = document.createElement("img");
			this.viewerImg.id="viewerImg";
			//viewerImg.src="./img/artworks/artwork1.jpg";
			this.viewer.appendChild(this.viewerImg);
			
			this.prevBtn = document.createElement("span");
			this.prevBtn.id="prevBtn";
			this.viewer.appendChild(this.prevBtn);
			
			this.nextBtn = document.createElement("span");
			this.nextBtn.id="nextBtn";
			this.viewer.appendChild(this.nextBtn);
			
			this.imgCounter = document.createElement("span");
			this.imgCounter.id="imgCounter";
			this.viewer.appendChild(this.imgCounter);
			
			this.imgTitle = document.createElement("span");
			this.imgTitle.id="imgTitle";
			this.viewer.appendChild(this.imgTitle);
			
			this.imgLabel = document.createElement("span");
			this.imgLabel.id="imgLabel";
			this.viewer.appendChild(this.imgLabel);
			
			this.closeBtn = document.createElement("span");
			this.closeBtn.id="closeBtn";
			this.viewer.appendChild(this.closeBtn);
			
			mc.parentNode.insertBefore(this.viewer, mc);
			//
			//console.log(turf);

				if(this.isMobile){
			
					this.closeBtn.addEventListener("touchstart",this.closeViewer,false);
					this.nextBtn.addEventListener("touchstart",this.nextImg,false);
					this.prevBtn.addEventListener("touchstart",this.prevImg,false);
					this.viewerImg.addEventListener("touchstart",this.nextImg,false);
			
				}else{
					this.closeBtn.addEventListener("mousedown",this.closeViewer,false);
					this.nextBtn.addEventListener("mousedown",this.nextImg,false);
					this.prevBtn.addEventListener("mousedown",this.prevImg,false);
					this.viewerImg.addEventListener("mousedown",this.nextImg,false);

			
				}
							 
				this.viewer.addEventListener('animationend', this.viewerAnimEnd, false);
			
				this.nextBtn.addEventListener('animationend', this.endAnim, false);
				this.prevBtn.addEventListener('animationend', this.endAnim, false);

				this.viewerImg.addEventListener('animationend', this.switchImg, false);
			
				this.galleryElements=this.gallery.getElementsByTagName("img");
			
				this.galleryLength=this.galleryElements.length;
				
				for(var i=0; i < this.galleryLength; i++){

					this.galleryElements[i].setAttribute("index",i);
					
					if(this.isMobile){	
						this.galleryElements[i].addEventListener("touchstart",this.openViewer,false);
					}else{
						this.galleryElements[i].addEventListener("mousedown",this.openViewer,false);

					}
					
			
				}
			
			},
 			removeGallery:function(){


				if(this.isMobile){
			
					this.closeBtn.removeEventListener("touchstart",this.closeViewer,false);
					this.nextBtn.removeEventListener("touchstart",this.nextImg,false);
					this.prevBtn.removeEventListener("touchstart",this.prevImg,false);
					this.viewerImg.removeEventListener("touchstart",this.nextImg,false);
			
				}else{
					this.closeBtn.removeEventListener("mousedown",this.closeViewer,false);
					this.nextBtn.removeEventListener("mousedown",this.nextImg,false);
					this.prevBtn.removeEventListener("mousedown",this.prevImg,false);
					this.viewerImg.removeEventListener("mousedown",this.nextImg,false);

			
				}

 				this.viewer.removeEventListener('animationend', this.viewerAnimEnd);

				this.nextBtn.removeEventListener('animationend', this.endAnim);
				this.prevBtn.removeEventListener('animationend', this.endAnim);
				this.viewerImg.removeEventListener('animationend', this.switchImg);

				for(var i=0; i < this.galleryLength; i++){
					
					if(this.isMobile){
						this.galleryElements[i].removeEventListener("touchstart",this.openViewer);
					}else{
						this.galleryElements[i].removeEventListener("mousedown",this.openViewer);

					}
					
				}
						while (this.viewer.firstChild) {
    							this.viewer.removeChild(this.viewer.firstChild);
					}
					
				this.viewer.parentElement.removeChild(this.viewer);
			
			}
    }

});




export default new Router({
  routes: [
    { path: '/', name: 'Home', component: Home },
    { path: '/Download', name: 'Download', component: Download },
    { path: '/Controls', name: 'Controls', component: Controls },
    { path: '/Screenshots', name: 'Screenshots', component: Screenshots },
    { path: '/Contact', name: 'Contact', component: Contact },
    //{ path: '/Options', name: 'Options', component: Options },
    //{ path: '/Showcase', name: 'Showcase', component: Showcase },
    { path: '/Artworks', name: 'Artworks', component: Artworks },
    { path: '/Links', name: 'Links', component: Links }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js